export default __webpack_public_path__ + "static/media/a009-6.f2a191a8.svg";